import React from "react";

interface ArrayInputFieldProps {
	label: string;
	items: string[];
	placeholder?: (index: number) => string;
	onAdd: () => void;
	onChange: (index: number, value: string) => void;
	onRemove: (index: number) => void;
	emptyMessage?: string;
}

const ArrayInputField: React.FC<ArrayInputFieldProps> = ({
	label,
	items,
	placeholder = (index) => `Item ${index + 1}`,
	onAdd,
	onChange,
	onRemove,
	emptyMessage = "No items added",
}) => {
	return (
		<div className="p-4 bg-white rounded-lg border border-gray-200">
			<div className="flex justify-between items-center mb-2">
				<label className="text-gray-900 text-base font-medium font-['Hanken Grotesk']">{label}</label>
				<button
					type="button"
					onClick={onAdd}
					className="text-blue-600 hover:text-blue-800 text-sm font-medium"
				>
					+ Add Line
				</button>
			</div>
			{items.map((item, index) => (
				<div key={index} className="flex gap-2 mb-2">
					<input
						type="text"
						value={item}
						onChange={(e) => onChange(index, e.target.value)}
						className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
						placeholder={placeholder(index)}
					/>
					<button
						type="button"
						onClick={() => onRemove(index)}
						className="px-3 py-2 text-red-600 hover:text-red-800"
					>
						Remove
					</button>
				</div>
			))}
			{items.length === 0 && <div className="text-gray-500 text-sm">{emptyMessage}</div>}
		</div>
	);
};

export default ArrayInputField;

